
// // import {
// //   FaBalanceScale,
// //   FaGlobeAsia,
// //   FaBookOpen,
// //   FaCalendarAlt,
// //   FaArrowRight,
// // } from "react-icons/fa";

// // const benefits = [
// //   {
// //     icon: <FaBalanceScale />,
// //     title: "Policy Advocacy",
// //   },
// //   {
// //     icon: <FaGlobeAsia />,
// //     title: "Global Network",
// //   },
// //   {
// //     icon: <FaBookOpen />,
// //     title: "Knowledge Hub",
// //   },
// //   {
// //     icon: <FaCalendarAlt />,
// //     title: "Priority Events",
// //   },
// // ];

// // export default function BecomeMember() {
// //   return (
// //     <section
// //       className="relative overflow-hidden py-10"
// //       style={{
// //         background:
// //           "linear-gradient(179.4deg, rgb(253,240,233) 2.2%, rgb(255,194,203) 96.2%)",
// //       }}
// //     >
// //       {/* decorative blur */}

// //       <div className="absolute top-0 left-0 w-[280px] h-[280px] bg-[#ff8fab]/20 blur-[100px] rounded-full" />

// //       <div className="absolute bottom-0 right-0 w-[240px] h-[240px] bg-[#f77f00]/10 blur-[90px] rounded-full" />

// //       <div className="max-w-[1280px] mx-auto px-4 relative z-10">

// //         {/* heading */}

// //         <div className="text-center max-w-[650px] mx-auto">

// //           <span className="uppercase tracking-[0.22em] text-[10px] font-bold text-[#B42318]">
// //             JOIN THE NETWORK
// //           </span>

// //           <h2
// //             className="mt-2 text-[26px] md:text-[40px] leading-none text-[#6A040F]"
// //             style={{
// //               fontFamily: "'Playfair Display', serif",
// //             }}
// //           >
// //             Become a{" "}
// //             <span className="italic text-[#D62828]">
// //               Member
// //             </span>
// //           </h2>

// //           <p className="mt-3 text-[#7A4A4A] text-[12px] leading-[1.8]">
// //             Unlock premium business opportunities, policy access
// //             and strategic networks.
// //           </p>

// //         </div>

// //         {/* main grid */}

// //         <div className="grid lg:grid-cols-12 gap-4 mt-8 items-center justify-center">

// //           {/* LEFT CARD */}

// //           <div className="lg:col-span-5">

// //             <div className="rounded-[26px] bg-white/60 backdrop-blur-xl border border-white/50 p-6 shadow-[0_10px_35px_rgba(0,0,0,0.08)] h-full">

// //               <span className="uppercase tracking-[0.18em] text-[10px] font-semibold text-[#B42318]">
// //                 Premium Membership
// //               </span>

// //               <div className="flex gap-5 mt-2 items-center justify-center">

// //               <h3
// //                 className="mt-3 text-[25px] leading-[1.05] text-[#5C000B]"
// //                 style={{
// //                   fontFamily: "'Playfair Display', serif",
// //                 }}
// //               >
// //                 Empowering India's
// //                 <br />
// //                 Business Future
// //               </h3>

// //               {/* stats */}

// //               <div className="flex gap-2">

// //                 <div className="rounded-2xl bg-[#fff7f7] px-5 py-3 border border-[#ffd6d6]">

// //                   <h4 className="text-[#C1121F] text-[20px] font-bold">
// //                     4.5L+
// //                   </h4>

// //                   <p className="text-[#777] text-[10px]">
// //                     Members
// //                   </p>

// //                 </div>

// //                 <div className="rounded-2xl bg-[#fff7f7] px-5 py-3 border border-[#ffd6d6]">

// //                   <h4 className="text-[#C1121F] text-[20px] font-bold">
// //                     400+
// //                   </h4>

// //                   <p className="text-[#777] text-[10px]">
// //                     Events
// //                   </p>

// //                 </div>

// //               </div>
// //               </div>

// //               {/* button */}

// //               <button className="mt-2 inline-flex items-center gap-2 px-5 py-3 rounded-full bg-[#B42318] text-white text-[12px] font-semibold hover:scale-[1.03] transition-all duration-300 shadow-lg">

// //                 Apply Membership

// //                 <FaArrowRight className="text-[11px]" />

// //               </button>

// //             </div>
// //           </div>

// //           {/* RIGHT CARDS */}

// //           <div className="lg:col-span-7">

// //             <div className="grid grid-cols-2 gap-3">

// //               {benefits.map((item, index) => (
// //                 <div
// //                   key={index}
// //                   className="group rounded-[22px]
// //                   bg-white/55
// //                   backdrop-blur-xl
// //                   border border-white/50
// //                   px-5 py-5
// //                   flex items-center gap-4
// //                   shadow-[0_8px_25px_rgba(0,0,0,0.05)]
// //                   hover:translate-y-[-3px]
// //                   hover:bg-white/75
// //                   transition-all duration-300"
// //                 >

// //                   <div
// //                     className="w-11 h-11 rounded-2xl
// //                     bg-gradient-to-br
// //                     from-[#D62828]
// //                     to-[#F77F00]
// //                     text-white
// //                     flex
// //                     items-center
// //                     justify-center
// //                     text-[14px]
// //                     shadow-md"
// //                   >
// //                     {item.icon}
// //                   </div>

// //                   <h3
// //                     className="text-[15px] text-[#5C000B]"
// //                     style={{
// //                       fontFamily: "'Playfair Display', serif",
// //                     }}
// //                   >
// //                     {item.title}
// //                   </h3>

// //                 </div>
// //               ))}

// //             </div>

// //           </div>

// //         </div>

// //       </div>
// //     </section>
// //   );
// // }






// // new new code 






// import {
//   FaBalanceScale,
//   FaGlobeAsia,
//   FaBookOpen,
//   FaCalendarAlt,
//   FaArrowRight,
// } from "react-icons/fa";

// const benefits = [
//   {
//     icon: <FaBalanceScale />,
//     title: "Policy Advocacy",
//   },
//   {
//     icon: <FaGlobeAsia />,
//     title: "Global Network",
//   },
//   {
//     icon: <FaBookOpen />,
//     title: "Knowledge Hub",
//   },
//   {
//     icon: <FaCalendarAlt />,
//     title: "Priority Events",
//   },
// ];

// export default function BecomeMember() {
//   return (
//     <section
//       className="relative overflow-hidden py-10"
//       style={{
//         background:
//           "linear-gradient(179.4deg, rgb(253,240,233) 2.2%, rgb(255,194,203) 96.2%)",
//       }}
//     >
//       {/* decorative blur */}
//       <div className="absolute top-0 left-0 w-[280px] h-[280px] bg-[#ff8fab]/20 blur-[100px] rounded-full" />
//       <div className="absolute bottom-0 right-0 w-[240px] h-[240px] bg-[#f77f00]/10 blur-[90px] rounded-full" />

//       <div className="max-w-[1280px] mx-auto px-4 relative z-10">

//         {/* Heading Section */}
//         <div className="text-center max-w-[650px] mx-auto">

//           {/* Caption Style */}
//           <span className="uppercase tracking-[0.22em] text-[11px] font-semibold text-[#B42318] font-rethink">
//             JOIN THE NETWORK
//           </span>

//           {/* H1 - Main Title (22px Semibold) */}
//           <h2 className="mt-2 text-[22px] md:text-[26px] leading-tight font-semibold text-[#6A040F] font-rethink">
//             Become a{" "}
//             <span className="italic text-[#D62828]">Member</span>
//           </h2>

//           {/* Body Text */}
//           <p className="mt-3 text-[#7A4A4A] text-[14px] leading-relaxed font-rethink">
//             Unlock premium business opportunities, policy access
//             and strategic networks.
//           </p>

//         </div>

//         {/* Main Grid */}
//         <div className="grid lg:grid-cols-12 gap-4 mt-8 items-center justify-center">

//           {/* LEFT CARD */}
//           <div className="lg:col-span-5">
//             <div className="rounded-[26px] bg-white/60 backdrop-blur-xl border border-white/50 p-6 shadow-[0_10px_35px_rgba(0,0,0,0.08)] h-full">

//               {/* Small Label */}
//               <span className="uppercase tracking-[0.18em] text-[11px] font-semibold text-[#B42318] font-rethink">
//                 Premium Membership
//               </span>

//               <div className="mt-4 flex flex-col md:flex-row gap-6 items-start">

//                 {/* Section Title - H2 Style */}
//                 <h3 className="text-[18px] leading-tight font-semibold text-[#5C000B] font-rethink">
//                   Empowering India's
//                   <br />
//                   Business Future
//                 </h3>

//                 {/* Stats */}
//                 <div className="flex gap-3">
//                   <div className="rounded-2xl bg-[#fff7f7] px-5 py-3 border border-[#ffd6d6] flex-shrink-0">
//                     <h4 className="text-[#C1121F] text-[20px] font-bold font-rethink">
//                       4.5L+
//                     </h4>
//                     <p className="text-[#777] text-[11px] font-rethink">
//                       Members
//                     </p>
//                   </div>

//                   <div className="rounded-2xl bg-[#fff7f7] px-5 py-3 border border-[#ffd6d6] flex-shrink-0">
//                     <h4 className="text-[#C1121F] text-[20px] font-bold font-rethink">
//                       400+
//                     </h4>
//                     <p className="text-[#777] text-[11px] font-rethink">
//                       Events
//                     </p>
//                   </div>
//                 </div>
//               </div>

//               {/* Button */}
//               <button className="mt-6 inline-flex items-center gap-2 px-6 py-3.5 rounded-full bg-[#B42318] text-white text-[14px] font-medium hover:scale-[1.03] transition-all duration-300 shadow-lg font-rethink">
//                 Apply Membership
//                 <FaArrowRight className="text-[13px]" />
//               </button>

//             </div>
//           </div>

//           {/* RIGHT CARDS */}
//           <div className="lg:col-span-7">
//             <div className="grid grid-cols-2 gap-3">
//               {benefits.map((item, index) => (
//                 <div
//                   key={index}
//                   className="group rounded-[22px]
//                   bg-white/55
//                   backdrop-blur-xl
//                   border border-white/50
//                   px-5 py-5
//                   flex items-center gap-4
//                   shadow-[0_8px_25px_rgba(0,0,0,0.05)]
//                   hover:translate-y-[-3px]
//                   hover:bg-white/75
//                   transition-all duration-300"
//                 >
//                   <div
//                     className="w-11 h-11 rounded-2xl
//                     bg-gradient-to-br
//                     from-[#D62828]
//                     to-[#F77F00]
//                     text-white
//                     flex
//                     items-center
//                     justify-center
//                     text-[14px]
//                     shadow-md"
//                   >
//                     {item.icon}
//                   </div>

//                   {/* Subsection / Benefit Title - 15px Medium */}
//                   <h3 className="text-[15px] font-medium text-[#5C000B] font-rethink">
//                     {item.title}
//                   </h3>
//                 </div>
//               ))}
//             </div>
//           </div>

//         </div>
//       </div>
//     </section>
//   );
// }




// new code 



import {
  FaBalanceScale,
  FaGlobeAsia,
  FaBookOpen,
  FaCalendarAlt,
  FaArrowRight,
} from "react-icons/fa";

const benefits = [
  {
    icon: <FaBalanceScale />,
    title: "Policy Advocacy",
  },
  {
    icon: <FaGlobeAsia />,
    title: "Global Network",
  },
  {
    icon: <FaBookOpen />,
    title: "Knowledge Hub",
  },
  {
    icon: <FaCalendarAlt />,
    title: "Priority Events",
  },
];

export default function BecomeMember() {
  return (
    <section
      className="relative overflow-hidden py-3 pt-3 pb-8"
      style={{
        backgroundImage: `url('https://www.assocham.org/assets/images/banner/membership-header.jpg')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Dark Overlay for Readability */}
      <div className="absolute inset-0 bg-gradient-to-r from-[#6A040F]/75 via-[#6A040F]/65 to-[#B42318]/70" />

      {/* Subtle accent overlay matching theme */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/30 to-transparent" />

      {/* Decorative elements */}
      <div className="absolute top-10 left-10 w-[300px] h-[300px] bg-[#ff8fab]/10 blur-[120px] rounded-full" />
      <div className="absolute bottom-10 right-10 w-[280px] h-[280px] bg-[#f77f00]/10 blur-[100px] rounded-full" />

      <div className="max-w-[1280px] mx-auto px-4 relative z-10">

        {/* Heading Section */}
        <div className="text-center max-w-[650px] mx-auto">

          {/* <span className="uppercase tracking-[0.22em] text-[11px] font-semibold text-white/90 font-rethink">
            JOIN THE NETWORK
          </span> */}

          <h2 className="mt-3 text-[26px] md:text-[32px] leading-tight font-semibold text-white font-rethink">
            Become a{" "}
            <span className="italic text-[#FFD23F]">Member</span>
          </h2>

          {/* <p className="mt-4 text-white/90 text-[15px] leading-relaxed font-rethink max-w-md mx-auto">
            Unlock premium business opportunities, policy access
            and strategic networks.
          </p> */}

        </div>

        {/* Main Grid */}
        <div className="grid lg:grid-cols-12 gap-6 mt-10 items-center">

          {/* LEFT CARD */}
          <div className="lg:col-span-5">
            <div className="rounded-[26px] bg-white/95 backdrop-blur-xl border border-white/70 px-5 py-3 shadow-xl h-full">

              {/* <span className="uppercase tracking-[0.18em] text-[11px] font-semibold text-[#B42318] font-rethink">
                Premium Membership
              </span> */}

              <div className="mt-5 flex flex-col md:flex-row gap-6 items-start">

                <h3 className="text-[19px] leading-tight font-semibold text-[#5C000B] font-rethink">
                  Empowering India's
                  <br />
                  Business Future
                </h3>

                <div className="flex gap-3">
                  <div className="rounded-2xl bg-[#fff7f7] px-5 py-3 border border-[#ffd6d6] flex-shrink-0">
                    <h4 className="text-[#C1121F] text-[21px] font-bold font-rethink">
                      4.5L+
                    </h4>
                    <p className="text-[#777] text-[11px] font-rethink">
                      Members
                    </p>
                  </div>

                  <div className="rounded-2xl bg-[#fff7f7] px-5 py-3 border border-[#ffd6d6] flex-shrink-0">
                    <h4 className="text-[#C1121F] text-[21px] font-bold font-rethink">
                      400+
                    </h4>
                    <p className="text-[#777] text-[11px] font-rethink">
                      Events
                    </p>
                  </div>
                </div>
              </div>

                <div className="button-div" style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
              <button className="mt-7 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#B42318] text-white text-[14px] font-medium hover:scale-[1.03] transition-all duration-300 shadow-lg font-rethink">
                Apply Membership
                <FaArrowRight className="text-[13px]" />
              </button>
              <button className="mt-7 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-[#B42318] text-white text-[14px] font-medium hover:scale-[1.03] transition-all duration-300 shadow-lg font-rethink">
                Benefits
                <FaArrowRight className="text-[13px]" />
              </button>
              </div>

            </div>
          </div>

          {/* RIGHT CARDS */}
          <div className="lg:col-span-7">
            <div className="grid grid-cols-2 gap-4">
              {benefits.map((item, index) => (
                <div
                  key={index}
                  className="group rounded-[22px]
                  bg-white/90 backdrop-blur-xl border border-white/60
                  px-5 py-3 flex items-center gap-4
                  shadow-lg hover:shadow-xl
                  hover:-translate-y-1 transition-all duration-300"
                >
                  <div
                    className="w-12 h-12 rounded-2xl
                    bg-gradient-to-br from-[#D62828] to-[#F77F00]
                    text-white flex items-center justify-center text-[15px] shadow-md"
                  >
                    {item.icon}
                  </div>

                  <h3 className="text-[15.5px] font-medium text-[#5C000B] font-rethink">
                    {item.title}
                  </h3>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}